<template>
  <b-form-group
    label="Kategori"
    label-for="id_product_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Kategori"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_product_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      >
        <template v-slot:option="option">
          {{ option.title }}
          <div v-if="option.main_categories">
            <small class="text-warning">{{ option.main_categories }}</small>
          </div>
          <div v-else>
            <small class="text-info">Ana Kategori</small>
          </div>
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProductsCategoriesCard',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('productCategories/getDataList', {
        select: [
          'product_categories.id AS id',
          'product_categories.title AS title',
          'main_categories.title AS main_categories',
        ],
        where: {
          'product_categories.id_product_categories !=': null,
        },
      })
    },
  },
}
</script>
